import 'angular:locale/data:de-AT';
import 'angular:locale/data:en-NZ';
import 'angular:locale/data:pt-BR';
import 'angular:locale/data:hi';
import 'angular:locale/data:no';
import 'angular:locale/data:en-ZA';
import 'angular:locale/data:fr';
import 'angular:locale/data:fr-CA';
import 'angular:locale/data:en-CA';
import 'angular:locale/data:en-IN';
import 'angular:locale/data:es';
import 'angular:locale/data:hu';
import 'angular:locale/data:de';
import 'angular:locale/data:pl';
import 'angular:locale/data:en';
import 'zone.js';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
